<template>
    <div>
        <div class="form-group">
            <label for="selected_city">
                {{ __('Város:') }}
            </label>
            <select
                id="selected_city"
                v-model="selectedCity"
                class="form-control"
                :class="{ 'is-invalid' : errors && Object.keys(errors).length > 0 && selectedCity === ''}"
            >
                <option
                    value=""
                    disabled
                >
                    {{ __('Válassz várost!') }}
                </option>
                <option
                    v-for="(city, index) in cities"
                    :key="index"
                >
                    {{ city }}
                </option>
            </select>
            <form-error
                v-if="errors && Object.keys(errors).length > 0 && selectedCity === ''"
                field="pickup_point_id"
                :errors="errors"
            />
            <div
                v-if="pickupPointsBySelectedCity"
                class="mt-2"
            >
                <div
                    v-if="errors && Object.keys(errors).length > 0"
                    class="form-group form-control distinct"
                    :class="{ 'is-invalid' : errors && Object.keys(errors).length > 0 }"
                >
                    <form-error
                        field="pickup_point_id"
                        :errors="errors"
                    />
                </div>
                <span>
                    {{ __('Válassz egy átvételi pontot:') }}
                </span>
                <div class="list-group form-control">
                    <a
                        v-for="(pickupPoint, index) in pickupPointsBySelectedCity"
                        :key="index"
                        class="list-group-item list-group-item-action"
                        :class="{ active: selectedPickupPoint === pickupPoint.id }"
                        @click.stop="selectedPickupPoint = pickupPoint.id"
                    >
                        <div class="d-flex w-100 justify-content-between">
                            <h5 class="mb-1">{{ pickupPoint.name }}</h5>
                            <small>
                                <span> {{ __('Telefon: ') }}</span>
                                {{ pickupPoint.phone }}
                            </small>
                        </div>
                        <p class="mb-1">
                            {{ pickupPoint.zip }}, {{ pickupPoint.city }}, {{ pickupPoint.address }}
                        </p>
                        <small>
                            <span>
                                {{ __('Nyitvatartás: ') }}
                            </span>
                            <span
                                class="opening-times"
                                v-html="pickupPoint.openingTimes"
                            />
                        </small>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { groupBy, keys, find } from 'lodash-es'

export default {
    props: {
        pickupPoints: {
            type: Array,
            required: true
        },
        pickupPoint: {
            type: Number,
            default: null
        },
        errors: {
            type: Object,
            default: null
        }
    },
    data: function() {
        return {
            selectedCity: '',
            selectedPickupPoint: null,
            initializingData: false
        }
    },
    computed: {
        pickupPointsBySelectedCity() {
            return this.groupByCities[this.selectedCity]
        },
        cities() {
            return keys(this.groupByCities)
        },
        groupByCities() {
            return groupBy(this.pickupPoints, 'city')
        },
    },
    watch: {
        selectedCity() {
            if ( !this.initializingData ) {
                this.selectedPickupPoint = null
                this.initializingData = false
            }
        },
        selectedPickupPoint(newPoint) {
            this.$emit('input', newPoint)
        }
    },
    created() {
        this.$bus.$on('reset-selected-city', () => {
            this.selectedCity = ''
            this.selectedPickupPoint = null
        })
        if (this.pickupPoint !== null) {
            const _pickupPoint = this.getPickupPointById(this.pickupPoint)
            this.initializingData = true
            this.selectedCity = _pickupPoint.city
            this.selectedPickupPoint = _pickupPoint.id
        }
    },
    mounted() {
        if ( !this.selectedCity && this.cities.length === 1 ) {
            this.selectedCity = this.cities[0]
        }
    },
    updated() {
        if ( !this.selectedPickupPoint
            && this.pickupPointsBySelectedCity
            && this.pickupPointsBySelectedCity.length === 1
        ) {
            this.selectedPickupPoint = this.pickupPointsBySelectedCity[0].id
        }
    },
    methods: {
        getPickupPointById(id) {
            return find(this.pickupPoints, { id })
        }
    }
}
</script>

<style scoped>
    .list-group > a {
      cursor: pointer;
    }

    .list-group > a.active:hover {
      color: white;
    }

    .list-group.form-control {
      display: inline-table;
    }

    .form-control.distinct {
      border: none;
      display: none;
      background: none;
    }

    .form-control.distinct.is-invalid {
      display: block;
    }

    .opening-times > :last-child {
      margin-bottom: 0 !important;
    }

    .is-invalid > .invalid-feedback {
      display: block;
    }
</style>
